module.exports = __webpack_public_path__ + "static/media/linkedin.745e692a.svg";